function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3334 9.33375H9.80672L9.62005 9.15375C10.4201 8.22042 10.8334 6.94708 10.6067 5.59375C10.2934 3.74042 8.74672 2.26042 6.88005 2.03375C4.06005 1.68708 1.68672 4.06042 2.03338 6.88042C2.26005 8.74708 3.74005 10.2938 5.59338 10.6071C6.94672 10.8338 8.22005 10.4204 9.15338 9.62042L9.33338 9.80708V10.3338L12.1667 13.1671C12.4401 13.4404 12.8867 13.4404 13.1601 13.1671C13.4334 12.8938 13.4334 12.4471 13.1601 12.1738L10.3334 9.33375ZM6.33338 9.33375C4.67338 9.33375 3.33338 7.99375 3.33338 6.33375C3.33338 4.67375 4.67338 3.33375 6.33338 3.33375C7.99338 3.33375 9.33338 4.67375 9.33338 6.33375C9.33338 7.99375 7.99338 9.33375 6.33338 9.33375Z",
  fill: "#969696"
});
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2a606aec6ff3bbf7d134c921bd204b93.svg";
export { ForwardRef as ReactComponent };